(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class LomsirAnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(
        this.querySelectorAll('[data-announcement-slide]')
      );

      this.interval = Math.max(
        Number(this.dataset.interval) || 4500,
        4000
      );

      this.current = 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.pause = () => this.stopRotation();
      this.resume = () => this.startRotation();

      this.handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.startRotation();
        }
      };

      this.handleVisibilityChange = () => {
        if (document.hidden) {
          this.stopRotation();
        } else {
          this.startRotation();
        }
      };

      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.handleFocusOut);

      document.addEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );

      this.startRotation();
    }

    showSlide(index) {
      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');

      this.current = index;

      this.slides[this.current].classList.add('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'false');
    }

    startRotation() {
      if (this.slides.length < 2 || document.hidden) return;

      this.stopRotation();

      this.timer = window.setInterval(() => {
        const nextIndex =
          (this.current + 1) % this.slides.length;

        this.showSlide(nextIndex);
      }, this.interval);
    }

    stopRotation() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    disconnectedCallback() {
      this.stopRotation();

      this.removeEventListener('mouseenter', this.pause);
      this.removeEventListener('mouseleave', this.resume);
      this.removeEventListener('focusin', this.pause);
      this.removeEventListener(
        'focusout',
        this.handleFocusOut
      );

      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
    }
  }

  if (!customElements.get('lomsir-announcement-rotator')) {
    customElements.define(
      'lomsir-announcement-rotator',
      LomsirAnnouncementRotator
    );
  }

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.always = [
        'always',
        'reduce-logo-size'
      ].includes(this.getAttribute('data-sticky-type'));

      this.bounds = {};
      this.setHeight();

      window
        .matchMedia('(max-width:990px)')
        .addEventListener('change', () => this.setHeight());

      if (this.always) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.current = 0;
      this.preventReveal = false;

      this.onScrollHandler = () => this.onScroll();

      this.addEventListener(
        'preventHeaderReveal',
        () => this.preventReveal = true
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.observe();
    }

    setHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    observe() {
      const observer = new IntersectionObserver((entries) => {
        this.bounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const top =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        top > this.current &&
        top > this.bounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.always) {
          this.hide();
        }
      } else if (
        top < this.current &&
        top > this.bounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.always &&
          !this.preventReveal
        ) {
          this.reveal();
        }
      } else if (top <= this.bounds.top) {
        this.reset();
      }

      this.current = top;
    }

    hide() {
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.header
        .querySelectorAll('header-menu')
        .forEach((item) => item.close());

      const modal =
        this.header.querySelector('details-modal');

      if (modal) {
        modal.close(false);
      }
    }

    reveal() {
      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.always) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomsir-campaign-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomsir-campaign')) {
    customElements.define('lomsir-campaign', class extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('[data-lcs-copy]');
        if (!this.copyButton || this.copyHandler) return;
        this.copyButton.hidden = false;
        this.copyHandler = async () => {
          const code = this.querySelector('[data-lcs-code]');
          const status = this.querySelector('[data-lcs-status]');
          if (!code || !status) return;
          this.copyButton.disabled = true;
          status.textContent = '';
          try {
            await navigator.clipboard.writeText(code.textContent.trim());
            if (this.isConnected) status.textContent = this.copyButton.dataset.success;
          } catch {
            if (!this.isConnected) return;
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(code);
            if (selection) {
              selection.removeAllRanges();
              selection.addRange(range);
            }
            status.textContent = this.copyButton.dataset.failure;
          } finally {
            this.copyButton.disabled = false;
          }
        };
        this.copyButton.addEventListener('click', this.copyHandler);
      }
      disconnectedCallback() {
        if (this.copyButton && this.copyHandler) {
          this.copyButton.removeEventListener('click', this.copyHandler);
        }
        this.copyHandler = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomsir-pdp-visual"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lomsir-formula-tabs'))customElements.define('lomsir-formula-tabs',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];if(!this.tabs.length||this.tabs.length!==this.panels.length)return;this.querySelector('[role=tablist]').hidden=false;this.activate(0,false);this.tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>this.activate(i,false),{signal});tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;if(e.key==='ArrowLeft')n=(i+this.tabs.length-1)%this.tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=this.tabs.length-1;if(n!==undefined){e.preventDefault();this.activate(n,true)}},{signal})})}
 activate(i,focus){this.tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(i===n));t.tabIndex=i===n?0:-1;this.panels[n].hidden=i!==n});if(focus){this.tabs[i].focus({preventScroll:true});this.tabs[i].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'})}}
 disconnectedCallback(){this.abort?.abort()}
});
if(!customElements.get('lomsir-pdp-visual'))customElements.define('lomsir-pdp-visual',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const main=document.querySelector('product-info[id^="MainProduct-"]');this.querySelectorAll('[data-lv-purchase]').forEach(a=>a.addEventListener('click',e=>{if(!main)return;e.preventDefault();const target=main.querySelector('variant-selects')||main.querySelector('.product__info-container')||main;target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});const focus=main.querySelector('button[name="add"]');focus?.focus({preventScroll:true})},{signal}));const bar=this.querySelector('.lv-mobile-purchase');if(bar&&main&&'IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting||main.getBoundingClientRect().top>0},{threshold:0});this.observer.observe(main)}}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();
})();
